import { Box, Container, Typography } from '@material-ui/core'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import Button from '@/components/button'
import InputText from '@/components/input-text'
import Loading from '@/components/loading'
import { useGetProjects } from '@/hooks/queries/use-get-projects'
import { useCompanies } from '@/hooks/use-companies'
import { routes } from '@/routes/config'

import { ProjectsTable } from './components/projects-table'
import { useStyles } from './styles'

interface FeedbackMessage {
  title: string
  description: string
}

export default function Projects() {
  const classes = useStyles()
  const { permissions } = useCompanies()
  const [search, setSearch] = useState('')
  const [feedbackMessage, setFeedbackMessage] = useState({} as FeedbackMessage)

  const { data, isLoading } = useGetProjects(setFeedbackMessage)

  const filteredProjects = useMemo(
    () =>
      data?.filter(
        (project) =>
          project.name.toLowerCase().includes(search.toLowerCase()) ||
          project.localization.toLowerCase().includes(search.toLowerCase()),
      ),
    [data, search],
  )

  const feedbackMessageResult = useMemo(
    () => (!search ? feedbackMessage : null),
    [search, feedbackMessage],
  )

  return (
    <Container className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Box className={classes.actionBar}>
            <Typography variant={'h1'}>Projetos</Typography>
            <InputText
              id='search-project'
              type='search'
              label={'Buscar projetos...'}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {permissions?.createUnities && (
              <Button
                to={routes.ProjectAdd()}
                outlined
                component={Link}
                role='link'
              >
                Adicionar projeto
              </Button>
            )}
          </Box>

          <ProjectsTable
            data={filteredProjects}
            feedbackMessage={feedbackMessageResult}
          />
        </>
      )}
    </Container>
  )
}
